import BaseService from "./base.service";

class UserService {

    users(page = null, search = null) {
        let params = [];
        if(search) {
            params.push({'key':'q', 'value':search});
        }
        return BaseService.apiGetRequest('users', page, params);
    }

    get(id) {
        return BaseService.apiGetRequest('users/'+id);
    }
    delete(role) {
		return BaseService.apiPostRequest('users/delete/', role);
    }
    add(role) {
        return BaseService.apiPostRequest('users/add', role);
    }
    update(id, role) {
        return BaseService.apiPostRequest('users/'+id, role);
    }
}
export default new UserService();
